import React, { useEffect } from 'react'
import { Form,Grid,Segment,Button } from 'semantic-ui-react';
import { addTipoEstudioOrion, editTipoEstudioOrion, getTipoEstudio } from '../../../../api/Orion/tipoEstudio';
import * as Yup from 'yup'
import { useAuth} from '../../../../hooks'
import {toast} from 'react-toastify'
import {useFormik} from 'formik'
import { Link } from "react-router-dom";
import "./AbmAdmin.scss";

export  function TipoEstudioOrionCreateEditShow(props) {
  const {auth} = useAuth()
	const {history} = props;
	const {id,type_action} = props.match.params
	const disabledGeneral = type_action === "show" ? true : false
	const isAddMode = !id;
  const [tipoEstudio,setTipoEstudio] = React.useState([])
  const formik = useFormik({
		initialValues:initialValues(tipoEstudio),
		validationSchema:Yup.object(validationSchema()),
		onSubmit:async (formValue)=>{
				if (isAddMode){
					const response = await addTipoEstudioOrion(formValue)
					try {
						
						if(response.status === "error"  ){
							toast.error(`Error en el sistema: ${JSON.stringify(response)}`)
						}else{
							
						
							 toast.success("Se guardó exitosamente el tipo estudio.",{
								onClose: () => {
									history.push(`/admin/tipo_estudio_orion/listado`);
								},
								autoClose: 1000
							})  
						}
						
					} catch (error) {
						toast.error(JSON.stringify(error.message))
					} 
				}else{
					const response = await editTipoEstudioOrion(id,formValue)
					try {
						
						if(response.status === "error"  ){
							toast.error(`Error en el sistema: ${JSON.stringify(response)}`)
						}else{
							
							
							 toast.success("Se guardó exitosamente el tipo estudio.",{
								onClose: () => {
									history.push(`/admin/tipo_estudio_orion/listado`);
								},
								autoClose: 1000
							})  
						}
						
					} catch (error) {
						toast.error(JSON.stringify(error.message))
					} 
					 
				} 
			
		},
		enableReinitialize: isAddMode ? false :false
	})
  useEffect(()=>{
		
    if(!isAddMode){
    const fetchTipoEstudio = async () =>{
      const servicio = await getTipoEstudio(`${props.match.params.id}`)
      .then(data=>{
          
          
          formik.setFieldValue("short_name",data.short_name)
          formik.setFieldValue("long_name",data.long_name)
          formik.setFieldValue("value_ars",data.value_ars)
        
          setTipoEstudio(data)
      })
    } 
    fetchTipoEstudio()
  }
  
 
  },[])

  return (
	<Form className="form-compact" onSubmit={formik.handleSubmit} style={{display:'grid'}}>
		<p><strong>Tipo de estudio</strong></p>
		<Grid as={Segment}>
			<Grid.Row className='segment_border_primary'>
				<Grid.Column computer={5} mobile={16} tablet={16}> 
					<h5>* Nombre corto</h5>
						<Form.Input  
							disabled={disabledGeneral}
							name="short_name"
							fluid 
							placeholder="Ingrese un nombre corto"
							value={formik.values.short_name} 
							onChange={(_,data)=>formik.setFieldValue("short_name",data.value)}
							error={formik.values.short_name !== "" ? false : true}
							
						/>

					</Grid.Column>
					<Grid.Column computer={5} mobile={16} tablet={16}>
					<h5>* Nombre largo</h5>
						<Form.Input  
							disabled={disabledGeneral}
							name="long_name"
							fluid 
							placeholder="Ingrese un nombre largo"
							value={formik.values.long_name} 
							onChange={(_,data)=>formik.setFieldValue("long_name",data.value)}
							error={formik.values.long_name !== "" ? false : true}
							
						/>
					</Grid.Column>
					<Grid.Column computer={5} mobile={16} tablet={16}>
					<h5>Valor ARS</h5>
						<Form.Input  
							disabled={disabledGeneral}
							type="number"
							name="value_ars"
							fluid 
							placeholder="Ingrese un valor"
							value={formik.values.value_ars} 
							onChange={(_,data)=>formik.setFieldValue("value_ars",data.value)}
							
							
						/>
						<p>Formato numérico sin puntos ni comas.</p>
					</Grid.Column>
				</Grid.Row>
			<Grid.Row>
				<Grid.Column computer={2} mobile={16} tablet={16}>
					<Button fluid disabled={disabledGeneral ? disabledGeneral : formik.isSubmitting} type="submit" content={isAddMode ? "Guardar" : "Actualizar"} primary />
				</Grid.Column>
				<Grid.Column computer={2} mobile={16} tablet={16}>
					<Button fluid content="Volver" primary component={Link} href='/admin/tipo_estudio_orion/listado'/>
				</Grid.Column>
			</Grid.Row>
		</Grid>
			 </Form>
	)
}
function validationSchema(){
	
	return {
		short_name: Yup.string().required(true),
		long_name: Yup.string().required(true)
  }
}

function initialValues(tipoEstudio){
	return{
		short_name: tipoEstudio?.short_name || "",
		long_name: tipoEstudio?.long_name || "",
		value_ars: tipoEstudio?.value_ars || ""
	}
}